import "vant/es/tabs/style";
import _Tabs from "vant/es/tabs";
import "vant/es/tab/style";
import _Tab from "vant/es/tab";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "vant/es/loading/style";
import _Loading from "vant/es/loading";
import "vant/es/popup/style";
import _Popup from "vant/es/popup";
import "vant/es/field/style";
import _Field from "vant/es/field";
import "vant/es/share-sheet/style";
import _ShareSheet from "vant/es/share-sheet";
import "vant/es/icon/style";
import _Icon from "vant/es/icon";
import "vant/es/collapse-item/style";
import _CollapseItem from "vant/es/collapse-item";
import "vant/es/collapse/style";
import _Collapse from "vant/es/collapse";
import "vant/es/nav-bar/style";
import _NavBar from "vant/es/nav-bar";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/action-sheet/style";
import _ActionSheet from "vant/es/action-sheet";
import "vant/es/search/style";
import _Search from "vant/es/search";
import "vant/es/tabbar/style";
import _Tabbar from "vant/es/tabbar";
import "vant/es/tabbar-item/style";
import _TabbarItem from "vant/es/tabbar-item";
import "vant/es/list/style";
import _List from "vant/es/list";
import "vant/es/cell/style";
import _Cell from "vant/es/cell";
import "vant/es/button/style";
import _Button from "vant/es/button";
// 按需全局引入 vant组件
import Vue from 'vue';
Vue.use(_Button);
Vue.use(_Cell);
Vue.use(_List);
Vue.use(_Tabbar).use(_TabbarItem);
Vue.use(_Search);
Vue.use(_ActionSheet);
Vue.use(_Toast);
Vue.use(_NavBar);
Vue.use(_Collapse);
Vue.use(_CollapseItem);
Vue.use(_Icon);
Vue.use(_ShareSheet);
Vue.use(_Field);
Vue.use(_Popup);
Vue.use(_Loading);
Vue.use(_Dialog);
Vue.use(_Tab);
Vue.use(_Tabs);
Vue.prototype.$toast = _Toast;